import { Contact } from "protico-sdk";
import { useCallback } from "react";
import useSWR, { KeyedMutator } from "swr";
import { useAppSelector } from ".";
import { getProticoClient } from "../utils/api";
import { checkAddress } from "../utils/format.utils";

export const getStableContacts = async (targetAddress: string) => {
  try {
    checkAddress(targetAddress);
  } catch (_) {
    return [];
  }
  try {
    const contacts = await getProticoClient().contact.get(targetAddress);
    const result = contacts.map((contact) => {
      return { ...contact, target: contact.target.toLowerCase() };
    });
    return result;
  } catch (err) {
    console.log("getStableContacts err: ", err);
    return [];
  }
};

/**
 * React hook for getting socialConnections
 * @category hook
 */
export default function useSocialConnection(): {
  isFetching: boolean;
  contacts: Contact[];
  isError: boolean;
  refetch: KeyedMutator<Contact[]>;
  getSocialConnection: (address: string) => Promise<Contact[]>;
} {
  const { currentAddress } = useAppSelector((state) => state.auth);
  const { data, error, mutate } = useSWR(
    [currentAddress, "useSocialConnection"],
    getStableContacts,
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
  const getSocialConnection = useCallback(async (address: string) => {
    return await getStableContacts(address);
  }, []);
  return {
    isFetching: !error && !data,
    contacts: data ?? [],
    isError: error,
    refetch: mutate,
    getSocialConnection,
  };
}
